import { setAuthToken, AuthTokenCookieConfig } from "@kaihong/utils/lib/khAuthToken";

const initState = {
  scrollDirection: "", //down-up-向上滚
  scrollHeight: 0, //滚动高度
  scrollDistance: 0, //滚动距离
  isClickCauseScroll: false, //是否点击导致滚动
  userDataChange: 0,
  userData: {},
  portalAuthorization: {
    accessToken: "",
    expireTime: "",
  },
  appTypes: [], // 所有应用类型
  releaseDetail: null, // 上架审核详情
  rulesDetail: null, // 业务规则详情
  superDeviceTemplateDetail: null, // 超级设备模板详情
  aiModelDetail: null, // 获取AI应用详情
  devicePluginDetail: null, // 获取设备插件详情
  solutionDetail: null, // 获取解决方案详情
  productManageDetail: null, // 获取产品管理详情
  agentDetail: null, // 获取智能体详情
};
interface Action {
  type: string;
  payload: any;
}
//接受state,传递过来的action
const portal = (state = initState, action: Action) => {
  const { type, payload } = action;
  switch (type) {
    case "setScrollDirection":
      return { ...state, scrollDirection: payload };
    case "setScrollHeight":
      return { ...state, scrollHeight: payload };
    case "setScrollDistance":
      return { ...state, scrollDistance: payload };
    case "setIsClickCauseScroll":
      return { ...state, isClickCauseScroll: payload };
    case "setUserDataChange":
      return { ...state, userDataChange: payload };
    case "setUserData":
      return { ...state, userData: payload };
    case "setPortalAuthorization":
      // eslint-disable-next-line no-case-declarations
      const { portalAuthorization } = state;
      // eslint-disable-next-line no-case-declarations
      const result = {
        ...portalAuthorization,
        ...payload,
      };

      setAuthToken("Authorization", result.accessToken);
      return { ...state, portalAuthorization: payload };
    case "setReleaseDetail":
      return { ...state, releaseDetail: payload };
    case "setRulesDetail":
      return { ...state, rulesDetail: payload };
    case "setSuperDeviceTemplateDetail":
      return { ...state, superDeviceTemplateDetail: payload };
    case "setAiModelDetail":
      return { ...state, aiModelDetail: payload };
    case "setDevicePluginDetail":
      return { ...state, devicePluginDetail: payload };
    case "setSolutionDetail":
      return { ...state, solutionDetail: payload };
    case "setProductManageDetail":
      return { ...state, productManageDetail: payload };
    case "setAgentDetail":
      return { ...state, agentDetail: payload };
    case "setAppTypes":
      return { ...state, appTypes: payload };
    default:
      return state;
  }
};

export default portal;
